import { DboCacheGroup } from '@cast/types';

import { useAbility } from '@cast/shared-ability-data-access';

import {
  isConnectionPoolingSupported,
  isConnectionTrackingSupported,
} from '../_utils';

type CacheGroupLike = Pick<
  DboCacheGroup,
  'helmChartVersion' | 'protocolType' | 'cacheStatus'
>;

export const useDboAbilities = () => {
  const ability = useAbility();
  const [canCreate, canUpdate, canDelete, isDboV2Enabled] = ability.canMany([
    ['create', 'OrganizationDbOptimizer'],
    ['update', 'OrganizationDbOptimizer'],
    ['delete', 'OrganizationDbOptimizer'],
    ['view', 'FeatureDboV2'],
  ]);

  const canViewConnectionTracking = (cacheGroup: CacheGroupLike) => {
    return isConnectionTrackingSupported(cacheGroup);
  };

  const canViewConnectionPooling = (cacheGroup: CacheGroupLike) => {
    return isConnectionPoolingSupported(cacheGroup);
  };

  const canToggleConnectionPooling = (cacheGroup: CacheGroupLike) => {
    return canViewConnectionPooling(cacheGroup) && canUpdate;
  };

  return {
    canCreate,
    canUpdate,
    canDelete,
    canViewConnectionPooling,
    canToggleConnectionPooling,
    canViewConnectionTracking,
    isDboV2Enabled,
  };
};
